module.exports = __webpack_public_path__ + "img/18.4-gallery.ace6b235.jpg";